import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import 'react-table/react-table.css';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import { DateRangePicker } from 'react-dates';


class ShippingList extends Component {

    constructor() {
        super();

        this.getShippingList = this.getShippingList.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);

        this._orderDatesChange = this.handleDatesChange('order').bind(this);
        this._orderFocusChange = this.handleFocusChange('order').bind(this);

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this.Configurations = new Configurations();

        this.state = {
            shippingList: [],
            isLoadingShippingList: true,
            pages: null,
            filters: {
                order: {
                    startDate: moment().subtract(60, 'days'),
                    endDate: moment(),
                },
                payment: {},
                logisticStatusList: [],
                paymentStatusList: [],
                productList: [],
                giftTypeList: [],
                shippingCompanyList: [],
                productTypeList: [],
                dispatchTypeList: [],
            },
        };

        this.columns = [
            {
                Header: 'Id',
                accessor: 'idRemessa',
                className: 'text-center pointer',
                width: 50
            },
            {
                Header: 'Status',
                accessor: 'status',
                className: 'text-center pointer',
                width: 200
            },
            {
                id: 'produtos',
                Header: 'Produtos',
                accessor: d => {
                    return (<span>{d.produtosEdicoes.join(',')}</span>)
                },
                className: 'text-center pointer',
                width: 300
            },
            {
                id: 'totalItens',
                Header: 'Total de Itens',
                accessor: 'totalItens',
                className: 'text-center pointer',
                width: 120
            },
            {
                Header: 'Transp.',
                accessor: 'transportadora',
                className: 'text-center pointer',
                width: 120
            },
            {
                id: 'dtCriacao',
                Header: 'Data Criação',
                accessor: d => {
                    return moment(d.dtCriacao)
                        .local()
                        .format("DD/MM/YYYY HH:mm:ss")
                },
                className: 'text-center pointer',
            },
            {
                Header: '',
                accessor: 'remessaReenvio',
                className: 'text-center pointer',
                Cell: row => (<span><strong>{row.value ? "Reenvio" : ""}</strong></span>)
            }
        ];
    }

    _outsideRange(day) {
        return day.format("YYYY-MM-DD") > moment().format("YYYY-MM-DD");
    }

    async getShippingList(o) {

        const _params = [];
        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
        }
        if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
            o.sorted = [];
            _params.push(`ordenacao=${o.sorted.map(item => item.id).join('&')}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        this.setState({ isLoadingShippingList: true })
        const _shipping = axios.get(this.Configurations.apiBasePath + `/logistica/remessas?${_params.join('&')}&dtInicio=${this.state.filters.order.startDate.format('YYYY-MM-DD')}&dtFim=${this.state.filters.order.endDate.format('YYYY-MM-DD')}`);

        _shipping.then(response => {
            this.setState({
                shippingList: response.data.remessas,
                pages: response.data.paginacao.totalPaginas
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingShippingList: false }));
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.startDate = startDate;
            dates.endDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    render() {
        return (
            <div className="carriers-list logistics">
                <div className="row">
                    <div className="col-10">
                        <h2 className="title-1">Remessas</h2>
                    </div>
                    <div className="col-2 text-right">
                        <button onClick={() => this.props.history.push("/logistica/remessas/nova")} className="btn btn-outline-success">Nova remessa</button>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12 text-center">
                        <div className='mb-4'>
                            <DateRangePicker
                                showClearDates
                                enableOutsideDays
                                isOutsideRange={this._outsideRange}
                                startDate={this.state.filters.order.startDate} // momentPropTypes.momentObj or null,
                                startDateId="dpOrderStartDate" // PropTypes.string.isRequired,
                                endDate={this.state.filters.order.endDate} // momentPropTypes.momentObj or null,
                                endDateId="dpOrderEndDate" // PropTypes.string.isRequired,
                                onDatesChange={this._orderDatesChange} // PropTypes.func.isRequired,
                                focusedInput={this.state.filters.order.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                onFocusChange={this._orderFocusChange} // PropTypes.func.isRequired,
                                displayFormat="DD/MM/YYYY"
                                startDatePlaceholderText="Data inicial"
                                endDatePlaceholderText="Data final"
                                phrases={this._phrases}
                            />
                            <button className="btn btn-outline-success ml-2" disabled={this.state.filters.order.startDate === null || this.state.filters.order.endDate === null} type="button" onClick={this.getShippingList}>
                                Filtrar
                            </button>
                        </div>
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.shippingList}
                                    columns={this.columns}
                                    onFetchData={this.getShippingList}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.isLoadingShippingList}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhuma remessa encontrada.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    pageSizeOptions={[20, 50, 100, 200, 300]}
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                if (rowInfo) {
                                                    // if (column.id === "desativar") handleOriginal();
                                                    // else this.selecionaEdicao(rowInfo.original.numeroEdicao)
                                                    this.props.history.push({ pathname: `/logistica/remessa/${rowInfo.original.idRemessa}` })
                                                }
                                            }
                                        }
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                </div>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}

export default ShippingList;
